import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import { reinstateAccount } from 'actions/tools/GladlyActions';
import environment from 'environment';
import { getSelectedCustomer } from '../../../../../selectors/tools';
import { getSimplrAccountIdOfSelectedTicket } from '../../../../../extractFromState';

const DTReinstateAccountThenSendMacro = () => {
  const dispatch = useDispatch();

  const { ACCOUNT_BASE_URL } = environment.accountData;
  const selectedCustomer = useSelector(getSelectedCustomer);
  const accountId = selectedCustomer?.customerId;
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);

  const handleNextButtonClick = async () => await dispatch(reinstateAccount());

  return (
    <DTCopyTextSendMacroView
      buttonText={'REINSTATE ACCOUNT'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={false}
      popupConfirmationText={'You are about to reinstate the account of this customer'}
      customErrorMessage={'Something went wrong when trying to reinstate the account.'}
      customErrorFields={{ ACCOUNT_BASE_URL, accountId, simplrAccountId }}
    />
  );
};

export default withConfirmation(DTReinstateAccountThenSendMacro);
